import React from "react";
import { css } from "@emotion/css";
import { founderImage } from "../assets/images";

const AboutFounder = () => {
    const aboutFounderStyles = {
        section: css`
            padding: 32px 0;
            background-color: white;

            @media (min-width: 640px) {
                padding: 48px 0;
            }

            @media (min-width: 1024px) {
                padding: 64px 0;
            }
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;

            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }

            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        textContentContainer: css`
            @media (min-width: 1024px) {
                border: 1px solid #e6cbcb;
                padding: 10px;
                border-radius: 5px;
                margin-right: 150px;
                padding-right: 120px;
            }
        `,
        grid: css`
            position: relative;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 32px;
            align-items: center;

            @media (min-width: 640px) {
                gap: 40px;
            }

            @media (min-width: 1024px) {
                grid-template-columns: 1fr auto;
                gap: 32px;
            }
        `,
        quoteSection: css`
            margin-bottom: 24px;
        `,
        quoteMark: css`
            color: #f97316;
            font-size: 2.5rem;
            font-weight: bold;

            @media (min-width: 640px) {
                font-size: 3rem;
            }

            @media (min-width: 1024px) {
                font-size: 3.75rem;
            }
        `,
        title: css`
            font-size: 1.5rem;
            font-weight: bold;
            color: #1f2937;
            display: inline;
            margin-left: 8px;

            @media (min-width: 640px) {
                font-size: 1.75rem;
            }

            @media (min-width: 1024px) {
                font-size: 1.875rem;
            }
        `,
        textContent: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
            color: #4b5563;
            line-height: 1.625;

            @media (min-width: 640px) {
                gap: 14px;
            }

            @media (min-width: 1024px) {
                gap: 16px;
            }
        `,
        paragraph: css`
            margin: 0;
        `,
        imageSection: css`
            display: flex;
            justify-content: center;

            @media (min-width: 1024px) {
                position: absolute;
                top: -10px;
                right: 0;
            }
        `,
        imageContainer: css`
            position: relative;
        `,
        founderImage: css`
            border-radius: 8px;

            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
                0 10px 10px -5px rgba(0, 0, 0, 0.04);
            width: 100%;
            max-width: 100%;
            height: 20rem;
            object-fit: cover;

            @media (min-width: 640px) {
                max-width: 24rem;
                height: 22rem;
            }

            @media (min-width: 1024px) {
                max-width: 28rem;
                height: 300px;
                border: 1px solid #e6cbcb;
                border-radius: 100%;
            }
        `,
        imageOverlay: css`
            position: absolute;
            inset: 0;
            ${
                "" /* background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.2),
                transparent
            ); */
            }
            border-radius: 8px;
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                text-align: justify;
            }
        `,
    };

    return (
        <section
            className={aboutFounderStyles.section}
            id="about-founder"
            aria-labelledby="about-founder-title"
        >
            <div className={aboutFounderStyles.container}>
                <div className={aboutFounderStyles.quoteSection}>
                    <span className={aboutFounderStyles.quoteMark}>"</span>
                    <h2 className={aboutFounderStyles.title}>
                        About Shreekalp
                    </h2>
                </div>
                <div className={aboutFounderStyles.grid}>
                    <div className={aboutFounderStyles.textContentContainer}>
                        <div className={aboutFounderStyles.textContent}>
                            <p className={aboutFounderStyles.paragraph}>
                                A Guide, a Master, a Mentor, a Companion for the
                                ultimate self-liberation of a human being.
                            </p>
                            <p className={aboutFounderStyles.paragraph}>
                                For Shreekalp, teaching is a means to guide the
                                human race towards community. He believes that
                                Enlightened Oneness can change the world
                                instantly.
                            </p>
                            <p className={aboutFounderStyles.paragraph}>
                                Shreekalp initiated to know the Self, to know
                                the Creator through self-inquiry methods. Talks
                                of life are: Dancing and singing are the natural
                                expressions of a human which are more vibrant if
                                done truly, he believes that dancing and singing
                                with Oneness can change the world.
                            </p>
                            <p className={aboutFounderStyles.paragraph}>
                                His ability to transform human life is a
                                reflection of his ultimate wisdom. Let's join
                                this new stage of Oneness with Shreekalp and
                                experience the natural bliss in life.
                            </p>
                        </div>
                    </div>

                    <div className={aboutFounderStyles.imageSection}>
                        <div className={aboutFounderStyles.imageContainer}>
                            <img
                                src={founderImage}
                                alt="Shreekalp"
                                className={aboutFounderStyles.founderImage}
                            />
                            <div
                                className={aboutFounderStyles.imageOverlay}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutFounder;
